'use client'

import { type Dispatch, type SetStateAction, useEffect, useRef, useState } from 'react'

export const useInfiniteScroll = (
  callback: (args: {
    isFetching: boolean
    setIsFetching: Dispatch<SetStateAction<boolean>>
  }) => void,
  customTrigger?: () => boolean,
) => {
  const [isFetching, setIsFetching] = useState(false)
  const refBox = useRef<HTMLInputElement>(null)

  useEffect(() => {
    refBox.current?.addEventListener('scroll', handleScroll)
    return () => {
      refBox.current?.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  useEffect(() => {
    if (!isFetching) return
    callback?.({ isFetching, setIsFetching })
  }, [isFetching])

  function handleScroll() {
    if (
      (customTrigger
        ? !customTrigger?.()
        : (refBox.current?.scrollHeight || 100) >
          (refBox.current?.scrollTop || 100) + (refBox.current?.offsetHeight || 100) + 200) ||
      isFetching
    ) {
      return
    }

    setIsFetching(true)
  }

  return { isFetching, refBox, setIsFetching }
}
